export default {
    cheatsheet: {
        title: "Feuille de picks",
        empty: {
            noPlaysAvailable: "Aucun jeu disponible",
        },
        separators: {
            noLongerPerfect: "Plus 100% sous cette ligne",
        },
        generate: {
            homeRow: "Générer ta feuille de picks",
            results: {
                title: "Ta cheatsheet",
                subtitle: "Générée",
            },
            actions: {
                generate: "Générer",
            },
            options: {
                all: "Tout",
            },
            empty: {
                title: "Aucune prop trouvée",
                subtitle: "Essaie de modifier tes sélections pour trouver plus de props.",
                action: "Ajuster les sélections",
            },
            outcome: {
                title: "Que recherches-tu?",
                subtitle: "Choisis Plus ou Moins.",
                over: "Plus",
                under: "Moins",
            },
            propType: {
                title: "Que préfères-tu?",
                subtitle: "Choisis les props de joueurs ou d'équipes.",
                player: "Props de joueurs",
                team: "Props d'équipes",
            },
            lineType: {
                title: "Quelles lignes veux-tu?",
                subtitle: "Choisis principales ou alternatives.",
                main: "Lignes principales",
                alternate: "Lignes alternatives",
            },
            cheatsheetType: {
                title: "Sur quoi devrait-on se baser?",
                subtitle: "Choisis la période à utiliser.",
                recentForm: "Forme récente",
                versusOpponent: "Contre l'adversaire",
                homeAwaySplits: "Domicile/extérieur",
            },
            games: {
                title: "Quels matchs inclure?",
                subtitle: "Inclus tous les matchs ou choisis ceux que tu veux.",
            },
            betTypes: {
                title: "Quelles props veux-tu?",
                subtitle: "Choisis les types de paris à inclure.",
            },
            operators: {
                title: "Où devrait-on chercher?",
                subtitle: "Choisis les cotes à inclure.",
            },
            loader: {
                prefix: "Analyse de",
                ready: "Feuille prête",
                accessibilityLabel: "Génération de ta feuille de picks",
                values: {
                    overs: "Plus...",
                    unders: "Moins...",
                    mainLines: "Lignes principales...",
                    alternateLines: "Lignes alternatives...",
                    recentForm: "Forme récente...",
                    versusOpponent: "Contre l'adversaire...",
                    homeAwaySplits: "Domicile/extérieur...",
                    todaysGames: "Matchs d'aujourd'hui...",
                    selectedGames: "{{count}} match(s) sélectionné(s)...",
                    allBetTypes: "Tous les types de paris...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} et {{second}}...",
                    manyBetTypes: "{{count}} types de paris...",
                    yourSportsbooks: "Tes sportsbooks...",
                    allSportsbooks: "Tous les sportsbooks...",
                    specificSportsbooks: "{{count}} sportsbook(s)...",
                    building: "Création de ta cheatsheet...",
                },
            },
        },
    },
};
